import { Box, InputLabel, Grid, IconButton, Divider, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import removeAccessMenuStyle from './RemoveAccessMenu.style';
import RemoveAccessMenu from './RemoveAccessMenu';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { setInvitedUsers } from '../Dashboard/Dashboard.actions';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useContext } from 'react';
import { UserPortalContext } from 'context/appcontext';
import {
	REMOVE_ACCESS,
	VIEWER,
	OWNER,
	WALMART,
	SUPPLIER_TAG,
	CATMAN_TAG,
	INCLUDE_DATA,
	EXCLUDE_DATA,
	RECIPE_ONLY_TITLE,
	EXT_USERS_TAG
} from 'constants/constant';
import bullet from 'assets/svgs/bullet.svg';
import { isCustomDataset } from 'helper/utils';

function SharedWithList(props) {
	const { userList, open, setOpen, data, isRemovable, hasModifyAccessMenu, setCount } = props;
	const classes = removeAccessMenuStyle();
	const isCustomDS = isCustomDataset(data?.customDatasetId);

	const portalUserContext = useContext(UserPortalContext);
	const { userDetails } = portalUserContext;
	const { userPersona } = userDetails?.result;

	const [anchorEl, setAnchorEl] = useState(null);
	const [updateAccessForUser, setUpdateAccessForUser] = useState({});
	const [index, setIndex] = useState(-1);

	const usersToRemoveAccess = useSelector((state) => state.dashboardReducer.usersToRemoveAccess);

	const dispatch = useDispatch();

	const removeInvites = (event, email) => {
		const usersAfterDelete = userList.filter((user) => user.email !== email);
		setCount(usersAfterDelete.length);
		dispatch(setInvitedUsers(usersAfterDelete));
	};

	const handleOpen = (event, user, index) => {
		event.stopPropagation();
		setAnchorEl((prev) => (prev ? null : event.currentTarget));
		setUpdateAccessForUser(user);
		setOpen((prev) => !prev);
		setIndex(index);
	};

	const handleClose = (event) => {
		event.stopPropagation();
		setAnchorEl(null);
		setOpen(false);
	};

	const getAccessLabel = (user) => {
		if (user.access === 'Owner') {
			return OWNER;
		}
		const findUser = usersToRemoveAccess.filter(
			(userToRemove) => user.email === userToRemove.email
		);
		if (findUser.length > 0) {
			if (findUser[0].removeAccess) {
				return REMOVE_ACCESS;
			} else if (findUser[0].isDataIncluded === true) {
				return INCLUDE_DATA;
			} else {
				return EXCLUDE_DATA;
			}
		} else {
			return VIEWER;
		}
	};

	const removeIconClassName = !isRemovable ? classes.hideButton : classes.crossIcon;
	let indexOfWOData = -1;

	const getUsersList = () => {
		if (!hasModifyAccessMenu) {
			return userList;
		}
		const usersWOData = [];
		const usersWData = [];

		userList.forEach((user) => {
			if (user.isDataIncluded === false) {
				usersWOData.push(user);
			} else {
				usersWData.push(user);
			}
		});
		indexOfWOData = usersWData.length;
		return usersWData.concat(usersWOData);
	};

	const getAdditionalMenu = () => {
		/**
		 * User persona | data can be included if report is shared with
		 * Merchant		| Merchant or DV
		 * Catman		| Merchant or DV
		 * Supplier		| Supplier or Mechant or DV
		 */

		const additionalOpt = ['includeData', 'excludeData'];
		if (userPersona === 'MERCHANT') {
			const noDataAllowedTypes = [SUPPLIER_TAG, CATMAN_TAG];
			if (!noDataAllowedTypes.includes(updateAccessForUser.userType)) {
				if (updateAccessForUser.isDataIncluded === false) {
					return additionalOpt[0];
				}
				return additionalOpt[1];
			}
		} else if (userPersona === 'CATMAN') {
			const noDataAllowedTypes = [CATMAN_TAG];
			if (!noDataAllowedTypes.includes(updateAccessForUser.userType)) {
				if (updateAccessForUser.isDataIncluded === false) {
					return additionalOpt[0];
				}
				return additionalOpt[1];
			}
		} else {
			if (updateAccessForUser.isDataIncluded === false) {
				return additionalOpt[0];
			}
			return additionalOpt[1];
		}
		return '';
	};

	const getCompanyName = (user) => {
		if (user.companyName) {
			return `${EXT_USERS_TAG} ${user.companyName}`;
		}
		return WALMART;
	};

	return (
		<>
			{getUsersList().map(function (user, index) {
				const isOwner = user.access === 'Owner';

				return (
					<>
						{indexOfWOData === index && (
							<>
								<Divider style={{ margin: '16px 0' }} />
								<Typography className={classes.recipeOnlyTitle}>{RECIPE_ONLY_TITLE}</Typography>
							</>
						)}
						<Box key={user.email} className={classes.userDetail}>
							<Grid container direction="row" alignItems="center">
								<Grid item xs={8}>
									<InputLabel
										className={
											classes.userNameLabel
										}>{`${user.firstName} ${user.lastName}`}</InputLabel>
									<InputLabel className={classes.userLoginIdLabel}>{user.email}</InputLabel>
									{user.userType && (
										<InputLabel className={classes.userLoginIdLabel}>
											{`${getCompanyName(user)} `}
											<img src={bullet} className={classes.bulletStyle}></img> {user.userType}
										</InputLabel>
									)}
								</Grid>
								<Grid item xs={4}>
									<InputLabel className={classes.userAccessLabel}>
										{getAccessLabel(user)}
										{!isOwner ? (
											<>
												{hasModifyAccessMenu && (
													<IconButton onClick={(event) => handleOpen(event, user, index)}>
														<ArrowDropDownIcon />
													</IconButton>
												)}
												<IconButton
													aria-label={`Remove Invitee, ${user.firstName} ${user.lastName}`}
													id={`remove-${index}`}
													className={removeIconClassName}
													onClick={(e) => {
														removeInvites(e, user?.email);
													}}>
													<CloseIcon fontSize="small" />
												</IconButton>
											</>
										) : (
											<></>
										)}
									</InputLabel>
								</Grid>
							</Grid>
						</Box>
					</>
				);
			})}
			<RemoveAccessMenu
				id="remove-access-menu"
				index={index}
				open={open}
				reportId={data?.reportId}
				updateAccessForUser={updateAccessForUser}
				anchorEl={anchorEl}
				handleClose={handleClose}
				additionalMenuOption={getAdditionalMenu()}
				isCustomDS={isCustomDS}
			/>
		</>
	);
}

SharedWithList.propTypes = {
	userList: PropTypes.array,
	open: PropTypes.bool.isRequired
};

export default SharedWithList;
